module.exports = "https://www.gc-pro.gnp.com.mx/875551791e158c894d1b967eae2b543b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/auto2.png
// module id = 1799
// module chunks = 0